import env from "react-dotenv";
import { Link } from "react-router-dom";
import { Container } from "@mui/system";
import React from "react";
import Navbar from "../Navbar/Navbar";
import classes from "./Login.module.css";
import JA from "../utils/images/JA-logo.png";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";
import { Login_Post_Call } from "../../Network_Calls/Login";

import OutlinedInput from "@mui/material/OutlinedInput";

const Login = () => {
  const [showPassword, setShowPassword] = React.useState(false);
  const [password, setPassword] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [fail, setFail] = React.useState(false);
  const navigate = useNavigate();
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const passwordChangeHandler = (event) => {
    setPassword(event.target.value);
  };
  const emailChangeHandler = (event) => {
    setEmail(event.target.value);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleGoogleAuthentication = () => {
    return window.open(`${process.env.REACT_APP_SERVER_URL}/auth/google`, "_self");
  };

  const handleMicrosoftAuthentication = () => {
    return window.open(`${process.env.REACT_APP_SERVER_URL}/auth/microsoft`, "_self");
  };
  ////Login form submission and api call////
  const loginFormSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await Login_Post_Call(email, password);
      console.log(response, "login comp");
      if (response.status === 200) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("origin","internal")
        navigate("/user/findcontact");
      } else {
        console.log("failed");
        setFail(true);
      }
    } catch (error) {
      console.log(error.response.status);
    }
    // setEmail("");
    // setPassword("");
  };

  return (
    <>
      <Navbar />
      <Container>
        <div className={classes.loginHead}>
          <img src={JA} alt="Journey Analytics" />
          <div className={classes.loginContent}>
            <h3>Welcome back!</h3>
            <p>Login to your account</p>
          </div>
        </div>
        <div className={classes.login}>
          <form onSubmit={loginFormSubmit}>
            <div className={classes.loginBtn}>
              <MailOutlineIcon />
              <input
                onChange={emailChangeHandler}
                value={email}
                placeholder="Email"
                type="email"
              />
            </div>
            <OutlinedInput
              sx={{
                marginBottom: "1em",
                width: "23em",
                border: "1px solid #22848f",
              }}
              onChange={passwordChangeHandler}
              value={password}
              id="outlined-adornment-password"
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              startAdornment={<LockOutlinedIcon />}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
            {/* 
            <div className={classes.loginBtn}>
              <LockOutlinedIcon />

              <input
                placeholder="Password"
                value={password}
                type={showPassword ? "text" : "password"}
                onChange={passwordChangeHandler}
              ></input>
              <div className={classes.passwordIcon}>
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </div>
            </div> */}
            {fail && (
              <p className={classes.fail}>
                Authentication Failed. Please try again.
              </p>
            )}
            <Button
              sx={{
                width:"100%",
                backgroundColor: "#1CB4C4",
                height: "3em",
              }}
              type="submit"
              variant="contained"
            >
              Login
            </Button>
          </form>
        </div>
        <div className={classes.loginHr}>
          <hr className={classes.firstHr} />
          <span>or</span>
          <hr className={classes.secondHr} />
        </div>
        <div className={classes.ssi}>
          <button
            onClick={handleGoogleAuthentication}
            variant="contained"
            className={classes.google}
           
            type="submit"
          >
            <i class="fa-brands fa-google"></i>
            Continue with Google
          </button>
          <button
            onClick={handleMicrosoftAuthentication}
            className={classes.google}
           
            type="submit"
            variant="contained"
          >
            <i class="fa-brands fa-microsoft"></i>
            Continue with Microsoft
          </button>
        </div>
        <br />
      </Container> 

      <div className={classes.signUp}>
        {/* <p>
          <Link style={{textDecoration:"underline",color:"#1CB4C4"}} to="/signup">SignUp{""}</Link> with{" "}
          <span className={classes.journey}>Journey</span>
          <span className={classes.analytics}>Analytics</span>
        </p> */}
      </div>
      <br />
      <Footer />
    </>
  );
};

export default Login;
